import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Card, Form, Button, Radio,
  Input, Select, InputNumber,
} from 'antd'
import history from 'utils/history'

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 5,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
  },
}

const tailLayout = {
  wrapperCol: {
    xs: {
      offset: 24,
      span: 24,
    },
    sm: {
      offset: 5,
      span: 12,
    },
  },
}

const FormUser = ({
  handleSubmit, isEdit, isSubmit,
  data, roleList,
}) => {
  const [form] = Form.useForm()

  useEffect(() => {

    if (isEdit && data) {
      form.setFieldsValue({
        name: data?.name || '',
        email: data?.email || '',
        position: data?.position || '',
        phone: data?.phone,
        status: data?.status || false,
        role_id: data?.role?.id || undefined,
      })
    }
  }, [data])

  const validateMessages = {
    required: "'${label}' wajib diisi!", // eslint-disable-line no-template-curly-in-string
  }

  return (
    <div>
      <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
        <h3 className="title-content mb-0">
          {isEdit ? 'Ubah' : 'Tambah'}
          {' '}
          User
        </h3>
      </div>
      <Card className="pt-4">
        <Form
          {...formItemLayout}
          form={form}
          name="survey"
          onFinish={handleSubmit}
          validateMessages={validateMessages}
        >
          <Form.Item label="Peran" name="role_id" rules={[{ required: true }]}>
            <Select
              placeholder="Pilih Peran"
            >
              {(roleList?.data || []).map(item => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)}
            </Select>
          </Form.Item>

          <Form.Item label="Nama" name="name" rules={[{ required: true }]}>
            <Input placeholder="name" />
          </Form.Item>

          <Form.Item label="Posisi" name="position" rules={[{ required: true }]}>
            <Input placeholder="position" />
          </Form.Item>

          <Form.Item label="Email" name="email" rules={[{ required: true }]}>
            <Input placeholder="email" />
          </Form.Item>

          <Form.Item label="No. Telepon" name="phone" rules={[{ required: true }]}>
            <Input placeholder="phone" />
          </Form.Item>

          <Form.Item label="Status" name="status" rules={[{ required: true }]} initialValue="inactive">
            <Radio.Group>
              <Radio value="active">Aktif</Radio>
              <Radio value="inactive">Inaktif</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item {...tailLayout} className="btn-primary-wrapper text-right">
            <Button onClick={() => window.history.back()} className="m-r-10" style={{ display: 'inline-block' }}>Batal</Button>
            <Button type="primary" loading={isSubmit} htmlType="submit">{isEdit ? 'Kirim Perubahan' : 'Buat'}</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

FormUser.propTypes = {
  handleSubmit: PropTypes.func,
  isSubmit: PropTypes.bool,
  isEdit: PropTypes.bool,
  data: PropTypes.object,
  roleList: PropTypes.object,
}

export default FormUser
